import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quoteLaneSoldByTypesAdapter = getAdapter({ idFieldName: 'value' });

const quoteLaneSoldByTypesSlice = createSlice({
  name: 'quoteLaneSoldByTypes',
  initialState: quoteLaneSoldByTypesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setQuoteLaneSoldByTypes: (state, { payload: { quoteLaneSoldByTypes } }) => {
      quoteLaneSoldByTypesAdapter.setAll(state, quoteLaneSoldByTypes);
    }
  }
});

const selectors = quoteLaneSoldByTypesAdapter.getSelectors(({ quoteLaneSoldByTypes }) => quoteLaneSoldByTypes);

export const getQuoteLaneSoldByTypes = state => selectors.selectAll(state);

export const { setQuoteLaneSoldByTypes } = quoteLaneSoldByTypesSlice.actions;

export default quoteLaneSoldByTypesSlice.reducer;
